import React from "react";
import heartsPng from "@images/icons/hearts.png";
import handHeart from "@images/icons/hand-heart.png";
import condolencePng from "@images/icons/condolence.png";
import styles from './TriBullet.module.scss'

const TriBullet = () => {


  return <section className="section">
    <div className="container ">
      <ul className={styles.tribullet}>
        <li>
          <img src={heartsPng} alt={''}/>
          <h3>Bereik iedereen die je wilt bereiken</h3>
          <p>Met bijna een miljoen bezoekers per maand op Mensenlinq wordt een veel breder publiek
            bereikt, inclusief vrienden, familie en kennissen buiten de regio en mensen die de krant niet
            lezen. Men kan het overlijdensbericht op Mensenlinq op elk moment bekijken en delen.</p>
        </li>
        <li>
          <img src={handHeart} alt={''}/>
          <h3>Ontvang online steunbetuigingen</h3>
          <p>Laat vrienden, familie en kennissen, ongeacht hun locatie, hun medeleven betuigen onder het overlijdensbericht. De online condoleances kunnen een blijvende steun zijn in moeilijke tijden.</p>
        </li>
        <li>
          <img src={condolencePng} alt={''}/>
          <h3>Lees steunbetuigingen op ieder moment terug</h3>
          <p>In tegenstelling tot de krant, waar het overlijdensbericht tijdelijk zichtbaar is, blijft het overlijdensbericht (inclusief de ontvangen online condoleances) beschikbaar op Mensenlinq.
            Zo is een troostende herinnering altijd binnen handbereik.</p>
        </li>
      </ul>
    </div>
  </section>
}
export default TriBullet
